import { render, staticRenderFns } from "./HomeProjectCard.vue?vue&type=template&id=06fb1a2b&scoped=true"
import script from "./HomeProjectCard.vue?vue&type=script&lang=js"
export * from "./HomeProjectCard.vue?vue&type=script&lang=js"
import style0 from "./HomeProjectCard.vue?vue&type=style&index=0&id=06fb1a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb1a2b",
  null
  
)

export default component.exports